import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { ProperBetLogo } from 'src/assets/logos/ProperBetLogo';
import { ProperBetBrandIcon } from 'src/assets/brandIcons/ProperBetBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const ProperBetMainLogoWrapper = withConfig(theme => styled('div', { label: 'ProperBetMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const ProperBetMainLogo = styled(ProperBetLogo, { label: 'ProperBetMainLogo' })`
    height: 32px;
    margin: 0 auto;
    width: 131px;
`;

export const ProperBetBrandIconWrapper = styled(ProperBetBrandIcon, { label: 'ProperBetBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 24px;
    margin: 0 auto;
    width: 60px;
`;

export const CompliancePopupLogo = styled(ProperBetLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
